import { type AstroApiClient } from '../api'

export type BirthPlaceSuggestion = {
  id: string
  displayName: string
  latitude: number
  longitude: number
}

export const searchBirthPlaceSuggestions = async (
  api: AstroApiClient,
  query: string,
): Promise<BirthPlaceSuggestion[]> => {
  const results = await api.apiGeoLocationSearch(query, undefined)

  return (results ?? []).map((result, index) => {
    const city = result.city?.trim() ?? ''
    const country = result.country?.trim() ?? ''
    const displayName = [city, country].filter(Boolean).join(', ')

    return {
      id: `${displayName || 'location'}-${index}-${result.latitude}-${result.longitude}`,
      displayName: displayName || `${result.latitude}, ${result.longitude}`,
      latitude: result.latitude ?? 0,
      longitude: result.longitude ?? 0,
    }
  })
}
